import { useQuery } from '@tanstack/react-query';
import { merchantDevicesHealthQueryOptions } from '../service/query-options';
import type { MerchantDevicesHealthQueryParams } from '../service/types';

export function useMerchantDevicesHealthQuery(params: MerchantDevicesHealthQueryParams) {
  return useQuery(merchantDevicesHealthQueryOptions(params));
}
